// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alarm-log-content {
  --background: #f4f5f6;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  color: #576d7c;
}

/* ---------------- PAGE HEADER ---------------- */

.alarm-log-page-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 1rem;
  width: min(960px, 100% - 2rem);
  margin: 0.9rem auto 0;
  padding: 0.85rem 1.1rem;
  background: #eeeeee;
  border: 1px solid #d7dce0;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.alarm-page-title-block {
  min-width: 0;
}

.alarm-page-title-block h1 {
  margin: 0;
  color: #576d7c;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 1.2;
}

.alarm-page-title-block p {
  margin: 0.2rem 0 0;
  color: #7a838b;
  font-size: 0.92rem;
  font-weight: 500;
  line-height: 1.25;
}

.alarm-back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  height: 2.35rem;
  padding: 0 0.9rem;
  border: 1px solid #d1d4d7;
  border-radius: 4px;
  background: #5a6f7c;
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.alarm-back-button:hover {
  background: #4f6370;
}

.alarm-back-icon {
  width: 0.95rem;
  height: 0.95rem;
  opacity: 0.85;
  filter: brightness(0) invert(1);
}

/* ---------------- PAGE CONTAINER ---------------- */

.alarm-log-container {
  width: min(960px, 100% - 2rem);
  margin: 0.75rem auto 1rem;
}

.alarm-log-panel {
  min-height: 70vh;
  padding: 1rem;
  background: #ffffff;
  border: 1px solid #d7dce0;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
}

/* ---------------- SECTION ---------------- */

.alarm-section {
  background: #ffffff;
  border: 1px solid #d7dce0;
  border-radius: 6px;
  padding: 0.75rem 0.9rem;
}

.alarm-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.65rem;
}

.alarm-section-title {
  margin: 0;
  color: #65b2e5;
  font-size: 17px;
  font-weight: 600;
  white-space: nowrap;
}

.alarm-section-line {
  flex: 1;
  height: 1px;
  margin-left: 0.6rem;
  border-bottom: 1px solid #d1d1d1;
}

.alarm-loading-inline {
  display: flex;
  align-items: center;
  margin-left: 0.75rem;
}

.alarm-loading-inline ion-spinner {
  width: 22px;
  height: 22px;
  --color: #65b2e5;
}

/* ---------------- EMPTY STATE ---------------- */

.alarm-empty-state {
  min-height: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1rem;
}

.alarm-empty-state p {
  margin: 0;
  color: #576d7c;
  font-size: 15px;
  font-weight: 600;
}

/* ---------------- ALARM LIST ---------------- */

.alarm-list {
  display: flex;
  flex-direction: column;
}

.alarm-row {
  border-bottom: 1px solid #d7dce0;
}

.alarm-row:last-child {
  border-bottom: none;
}

.alarm-row-main {
  width: 100%;
  min-height: 2.55rem;
  padding: 0.45rem 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 1rem;
  border: 0;
  background: transparent;
  color: #576d7c;
  text-align: left;
  cursor: pointer;
}

.alarm-row-main:hover {
  background: #f8f9fa;
}

.alarm-main-text {
  min-width: 0;
}

.alarm-title {
  margin: 0;
  color: #576d7c;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.alarm-summary {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 0.55rem;
  color: #576d7c;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.alarm-ecu {
  padding-right: 0.55rem;
  border-right: 1px solid #d7dce0;
}

.alarm-count {
  min-width: 2rem;
  text-align: right;
}

/* ---------------- DETAILS ---------------- */

.alarm-details {
  padding: 0.55rem 0.75rem 0.75rem;
  background: #f8f9fa;
  border-top: 1px solid #e1e5e8;
}

.alarm-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.45rem 1rem;
}

.alarm-detail-item {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
}

.alarm-detail-label {
  color: #6a7178;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.alarm-detail-value {
  color: #576d7c;
  font-size: 13px;
  font-weight: 500;
  text-align: right;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.alarm-details-action {
  display: flex;
  justify-content: flex-end;
  padding-top: 0.65rem;
}

.alarm-more-button {
  border: 0;
  background: transparent;
  color: #65b2e5;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.alarm-more-button:hover {
  text-decoration: underline;
}

/* ---------------- ACTIONS ---------------- */

.alarm-action-section {
  margin-top: 0.8rem;
  padding: 0.75rem 0.9rem;
  background: #ffffff;
  border: 1px solid #d7dce0;
  border-radius: 6px;
}

.alarm-action-row {
  display: flex;
  justify-content: center;
}

.alarm-clear-button {
  width: auto;
  min-width: 8rem;
  height: 2.4rem;
  --background: #5a6f7c;
  --background-hover: #4f6370;
  --background-activated: #42535d;
  --box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  --color: #ffffff;
  font-weight: 600;
}

.alarm-deep-clear-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  color: #576d7c;
  font-size: 14px;
  font-weight: 600;
}

.alarm-deep-clear-row ion-checkbox {
  --size: 16px;
  --checkbox-background-checked: #5a6f7c;
  --border-color-checked: #5a6f7c;
  --checkmark-color: #ffffff;
}

/* ---------------- RESPONSIVE ---------------- */

@media (max-width: 900px) {
  .alarm-log-page-header,
  .alarm-log-container {
    width: calc(100% - 1rem);
  }

  .alarm-log-panel {
    padding: 0.75rem;
  }

  .alarm-details-grid {
    grid-template-columns: 1fr;
  }

  .alarm-detail-value {
    text-align: left;
  }
}

@media (max-width: 600px) {
  .alarm-log-page-header {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .alarm-back-button {
    justify-self: end;
  }

  .alarm-row-main {
    grid-template-columns: 1fr;
    gap: 0.35rem;
  }

  .alarm-summary {
    justify-content: flex-start;
  }

  .alarm-title {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/alarm-log/alarm-log.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,cAAA;AAAF;;AAGA,kDAAA;;AAEA;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EAEA,8BAAA;EACA,qBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AAHF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EAEA,eAAA;EACA,iBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,cAAA;EACA,kBAAA;EACA,gBAAA;EAEA,eAAA;EACA,mBAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,+BAAA;AAPF;;AAUA,qDAAA;;AAEA;EACE,8BAAA;EACA,yBAAA;AARF;;AAWA;EACE,gBAAA;EACA,aAAA;EAEA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AATF;;AAYA,8CAAA;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAVF;;AAaA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,OAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAVF;;AAaA,kDAAA;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AAXF;;AAcA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAXF;;AAcA,iDAAA;;AAEA;EACE,aAAA;EACA,sBAAA;AAZF;;AAeA;EACE,gCAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EAEA,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EAEA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,mBAAA;AAdF;;AAiBA;EACE,YAAA;AAdF;;AAiBA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,YAAA;EAEA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,sBAAA;EACA,+BAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,iBAAA;AAhBF;;AAmBA,8CAAA;;AAEA;EACE,gCAAA;EACA,mBAAA;EACA,6BAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAjBF;;AAoBA;EACE,0BAAA;AAjBF;;AAoBA,8CAAA;;AAEA;EACE,kBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,uBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,eAAA;EACA,cAAA;EAEA,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,2CAAA;EACA,gBAAA;EAEA,gBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EAEA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,sCAAA;EACA,+BAAA;EACA,0BAAA;AAtBF;;AAyBA,iDAAA;;AAEA;EACE;;IAEE,wBAAA;EAvBF;;EA0BA;IACE,gBAAA;EAxBF;;EA2BA;IACE,0BAAA;EAzBF;;EA4BA;IACE,gBAAA;EA1BF;AACF;;AA6BA;EACE;IACE,0BAAA;IACA,YAAA;EA3BF;;EA8BA;IACE,iBAAA;EA5BF;;EA+BA;IACE,0BAAA;IACA,YAAA;EA7BF;;EAgCA;IACE,2BAAA;EA9BF;;EAiCA;IACE,mBAAA;EA/BF;AACF","sourcesContent":[".alarm-log-content {\r\n  --background: #f4f5f6;\r\n  --padding-top: 0;\r\n  --padding-bottom: 0;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n\r\n  color: #576d7c;\r\n}\r\n\r\n/* ---------------- PAGE HEADER ---------------- */\r\n\r\n.alarm-log-page-header {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) auto;\r\n  align-items: center;\r\n  gap: 1rem;\r\n\r\n  width: min(960px, calc(100% - 2rem));\r\n  margin: 0.9rem auto 0;\r\n  padding: 0.85rem 1.1rem;\r\n\r\n  background: #eeeeee;\r\n  border: 1px solid #d7dce0;\r\n  border-radius: 6px;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.alarm-page-title-block {\r\n  min-width: 0;\r\n}\r\n\r\n.alarm-page-title-block h1 {\r\n  margin: 0;\r\n  color: #576d7c;\r\n  font-size: 1.6rem;\r\n  font-weight: 600;\r\n  line-height: 1.2;\r\n}\r\n\r\n.alarm-page-title-block p {\r\n  margin: 0.2rem 0 0;\r\n  color: #7a838b;\r\n  font-size: 0.92rem;\r\n  font-weight: 500;\r\n  line-height: 1.25;\r\n}\r\n\r\n.alarm-back-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n\r\n  height: 2.35rem;\r\n  padding: 0 0.9rem;\r\n\r\n  border: 1px solid #d1d4d7;\r\n  border-radius: 4px;\r\n  background: #5a6f7c;\r\n\r\n  color: #ffffff;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.alarm-back-button:hover {\r\n  background: #4f6370;\r\n}\r\n\r\n.alarm-back-icon {\r\n  width: 0.95rem;\r\n  height: 0.95rem;\r\n  opacity: 0.85;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n/* ---------------- PAGE CONTAINER ---------------- */\r\n\r\n.alarm-log-container {\r\n  width: min(960px, calc(100% - 2rem));\r\n  margin: 0.75rem auto 1rem;\r\n}\r\n\r\n.alarm-log-panel {\r\n  min-height: 70vh;\r\n  padding: 1rem;\r\n\r\n  background: #ffffff;\r\n  border: 1px solid #d7dce0;\r\n  border-radius: 6px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n/* ---------------- SECTION ---------------- */\r\n\r\n.alarm-section {\r\n  background: #ffffff;\r\n  border: 1px solid #d7dce0;\r\n  border-radius: 6px;\r\n  padding: 0.75rem 0.9rem;\r\n}\r\n\r\n.alarm-section-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 0.65rem;\r\n}\r\n\r\n.alarm-section-title {\r\n  margin: 0;\r\n  color: #65b2e5;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.alarm-section-line {\r\n  flex: 1;\r\n  height: 1px;\r\n  margin-left: 0.6rem;\r\n  border-bottom: 1px solid #d1d1d1;\r\n}\r\n\r\n.alarm-loading-inline {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 0.75rem;\r\n}\r\n\r\n.alarm-loading-inline ion-spinner {\r\n  width: 22px;\r\n  height: 22px;\r\n  --color: #65b2e5;\r\n}\r\n\r\n/* ---------------- EMPTY STATE ---------------- */\r\n\r\n.alarm-empty-state {\r\n  min-height: 10rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  padding: 1rem;\r\n}\r\n\r\n.alarm-empty-state p {\r\n  margin: 0;\r\n  color: #576d7c;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ---------------- ALARM LIST ---------------- */\r\n\r\n.alarm-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.alarm-row {\r\n  border-bottom: 1px solid #d7dce0;\r\n}\r\n\r\n.alarm-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.alarm-row-main {\r\n  width: 100%;\r\n  min-height: 2.55rem;\r\n  padding: 0.45rem 0;\r\n\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) auto;\r\n  align-items: center;\r\n  gap: 1rem;\r\n\r\n  border: 0;\r\n  background: transparent;\r\n  color: #576d7c;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.alarm-row-main:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.alarm-main-text {\r\n  min-width: 0;\r\n}\r\n\r\n.alarm-title {\r\n  margin: 0;\r\n  color: #576d7c;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 1.25;\r\n\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.alarm-summary {\r\n  display: grid;\r\n  grid-template-columns: auto auto;\r\n  align-items: center;\r\n  gap: 0.55rem;\r\n\r\n  color: #576d7c;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.alarm-ecu {\r\n  padding-right: 0.55rem;\r\n  border-right: 1px solid #d7dce0;\r\n}\r\n\r\n.alarm-count {\r\n  min-width: 2rem;\r\n  text-align: right;\r\n}\r\n\r\n/* ---------------- DETAILS ---------------- */\r\n\r\n.alarm-details {\r\n  padding: 0.55rem 0.75rem 0.75rem;\r\n  background: #f8f9fa;\r\n  border-top: 1px solid #e1e5e8;\r\n}\r\n\r\n.alarm-details-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 0.45rem 1rem;\r\n}\r\n\r\n.alarm-detail-item {\r\n  display: grid;\r\n  grid-template-columns: auto minmax(0, 1fr);\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  min-width: 0;\r\n}\r\n\r\n.alarm-detail-label {\r\n  color: #6a7178;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.alarm-detail-value {\r\n  color: #576d7c;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  text-align: right;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.alarm-details-action {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding-top: 0.65rem;\r\n}\r\n\r\n.alarm-more-button {\r\n  border: 0;\r\n  background: transparent;\r\n  color: #65b2e5;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.alarm-more-button:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ---------------- ACTIONS ---------------- */\r\n\r\n.alarm-action-section {\r\n  margin-top: 0.8rem;\r\n  padding: 0.75rem 0.9rem;\r\n\r\n  background: #ffffff;\r\n  border: 1px solid #d7dce0;\r\n  border-radius: 6px;\r\n}\r\n\r\n.alarm-action-row {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.alarm-clear-button {\r\n  width: auto;\r\n  min-width: 8rem;\r\n  height: 2.4rem;\r\n\r\n  --background: #5a6f7c;\r\n  --background-hover: #4f6370;\r\n  --background-activated: #42535d;\r\n  --box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\r\n  --color: #ffffff;\r\n\r\n  font-weight: 600;\r\n}\r\n\r\n.alarm-deep-clear-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n\r\n  margin-top: 0.75rem;\r\n  color: #576d7c;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.alarm-deep-clear-row ion-checkbox {\r\n  --size: 16px;\r\n  --checkbox-background-checked: #5a6f7c;\r\n  --border-color-checked: #5a6f7c;\r\n  --checkmark-color: #ffffff;\r\n}\r\n\r\n/* ---------------- RESPONSIVE ---------------- */\r\n\r\n@media (max-width: 900px) {\r\n  .alarm-log-page-header,\r\n  .alarm-log-container {\r\n    width: calc(100% - 1rem);\r\n  }\r\n\r\n  .alarm-log-panel {\r\n    padding: 0.75rem;\r\n  }\r\n\r\n  .alarm-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .alarm-detail-value {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .alarm-log-page-header {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .alarm-back-button {\r\n    justify-self: end;\r\n  }\r\n\r\n  .alarm-row-main {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.35rem;\r\n  }\r\n\r\n  .alarm-summary {\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .alarm-title {\r\n    white-space: normal;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
